import { buildMeta } from "../lib/seo.js";
import ContactPage from "../components/ContactPage/ContactPage.jsx";

const PAGE = {
  title: "Contact Us",
  description:
    "Talk to RDV Systems about road safety analysis or 3D visualization for your project. Offices in Manchester, NH and Modi'in, Israel.",
  path: "/contact",
};

export function meta() {
  return buildMeta(PAGE);
}

export default function Contact() {
  return (
    <ContactPage
      title="Contact us"
      lead="Tell us what you are working on, and we will reply within one business day."
      path={PAGE.path}
    />
  );
}
